import { render, staticRenderFns } from "./FieldValueV2.vue?vue&type=template&id=00e6d710&scoped=true&lang=pug"
import script from "./FieldValueV2.vue?vue&type=script&lang=js"
export * from "./FieldValueV2.vue?vue&type=script&lang=js"
import style0 from "./FieldValueV2.vue?vue&type=style&index=0&id=00e6d710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6d710",
  null
  
)

export default component.exports